__turbopack_context__.v({
  "className": "LnoEjq_className",
  "variable": "LnoEjq_variable",
});
